import { Banner, Button, LegacyStack, Text } from "@shopify/polaris";
import { GettingStartedStoreAccess } from "../../../libs/store";
import React, { useEffect, useState } from "react";
import { useCheckIfThemeIsValid } from "../../../libs/hooks/useCheckIfThemeIsValid";

export function UnsupportedThemeBanner() {
  const { checkIfThemeIsValid } = useCheckIfThemeIsValid();
  const chosenThemeId = GettingStartedStoreAccess.useChosenThemeId();
  const { isThemeValid } = GettingStartedStoreAccess.useThemeValidation();

  const [isValidatingTheme, setIsValidatingTheme] = useState(true);

  useEffect(() => {
    if (!chosenThemeId) {
      return;
    }

    setIsValidatingTheme(true);

    void Promise.resolve(checkIfThemeIsValid(chosenThemeId)).finally(() => setIsValidatingTheme(false));
  }, [chosenThemeId]);

  if (isValidatingTheme || isThemeValid || !chosenThemeId) {
    return <React.Fragment />;
  }

  return (
    <Banner title="Unsupported theme" status="warning">
      <LegacyStack vertical>
        <Text as="span" variant="bodyMd">
          You have selected an unsupported theme. If you need assistance, our support team can help.
        </Text>
        <Button monochrome url="mailto:support@smartrr.com">
          Contact support for help
        </Button>
      </LegacyStack>
    </Banner>
  );
}
